import type { RouteRecordRaw } from 'vue-router'
import { EChannelRouter } from '@/shared/enum/channel-router.enum'
import getCurrentChannelRouter from '@/shared/utils/get-current-channel-router'
import getTokenFromUrl from '@/shared/utils/get-token-from-url'
import { routesMce } from '@/router/mce'
import { routesMcapp } from '@/router/mcapp'
import { routesMcweb } from '@/router/mcweb'
import { routesChatbot } from '@/router/chatbot'

/**
 * Orchestrates the routes for the application based on the detected channel router.
 * @function orchestador
 * @returns {Array<RouteRecordRaw>} An array of route objects for the detected channel router.
 */
export const orchestador = (): RouteRecordRaw[] => {
  const token = getTokenFromUrl()
  const channel = getCurrentChannelRouter(token || '')
  const routes = {
    [EChannelRouter.MCE]: routesMce,
    [EChannelRouter.CHATBOT]: routesChatbot,
    [EChannelRouter.MCAPP]: routesMcapp,
    [EChannelRouter.MCWEB]: routesMcweb
  }
  return routes[channel]
}
